/* eslint-disable no-unused-vars */
import React, { useRef } from 'react';
import {
  Dialog, DialogTitle, DialogContent, Typography, DialogActions, makeStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import PrimaryButton from './PrimaryButton';

const useStyles = makeStyles((theme) => ({
  customAlert: {
    padding: 20,
  },
}));

export default function SimpleAlert({
  open, setOpen, header, body, callback, id,
}) {
  const classes = useStyles();

  const dialogRef = useRef(null);

  const handleClose = () => {
    setOpen(false);
    if (callback) callback();
  };

  return (
    <Dialog
      open={open}
      ref={dialogRef}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" className={classes.customAlert}>{header || 'Alert'}</DialogTitle>
      <DialogContent>
        <Typography
          style={{
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
          }}
        >
          {body}
        </Typography>
      </DialogContent>
      <DialogActions className={classes.customAlert}>
        <PrimaryButton id={`${id}`} onClick={handleClose} color="primary" autoFocus>
          Close
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}
SimpleAlert.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  callback: PropTypes.func,
  id: PropTypes.string,
};
SimpleAlert.defaultProps = {
  callback: () => { },
  id: undefined,
};
